const VERSION = '6.9.1';

export { VERSION };
